import styled from 'styled-components'
import { Layout } from 'antd'

export const WrapLayout = styled(Layout)`
  justify-content: center;
`
